import React from "react";

interface CreditCardIconProps {
  className?: string;
}

export const CreditCardIcon = ({ className }: CreditCardIconProps) => (
  <svg
    width="28"
    height="22"
    viewBox="0 0 28 22"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27 0H1C0.446875 0 0 0.446875 0 1V21C0 21.5531 0.446875 22 1 22H27C27.5531 22 28 21.5531 28 21V1C28 0.446875 27.5531 0 27 0ZM2.25 2.25H25.75V6H2.25V2.25ZM25.75 19.75H2.25V8.75H25.75V19.75ZM18.3438 17.75H23.5C23.6375 17.75 23.75 17.6375 23.75 17.5V15.25C23.75 15.1125 23.6375 15 23.5 15H18.3438C18.2062 15 18.0938 15.1125 18.0938 15.25V17.5C18.0938 17.6375 18.2062 17.75 18.3438 17.75Z"
      fill="black"
    />
  </svg>
);

CreditCardIcon.defaultProps = {
  className: "",
};
